<template>
    <div class="main-check-work"  v-loading.fullscreen.lock="loading">
        <div class="check-work">
            <el-row>
                <el-col :sm="18" :lg="24">
                    <el-result icon="error" title="错误信息" subTitle="证书编号错误或编码错误！">
                    <template slot="extra">
                        <el-button size="medium" @click="reload">再试一次</el-button>
                        <el-button type="primary" size="medium" @click="backPage">返回</el-button>
                    </template>
                    </el-result>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import { checkWork } from '@/api/business'
    import router from '@/router';
    import CryptoJS from 'crypto-js';
     export default {
        name:'check-work-error',
        components:{
        },
        data () {
            return { 
                activeName:1, 
                certNo:"",
                fileHash:"",
                fileList:[],
                loading:false
            }
        },
        mounted() {
        //    this.init()
        // console.log(router.currentRoute);
            this.certNo = router.currentRoute.query.certNo;
            this.fileHash = router.currentRoute.query.fileHash;
        },
        methods: {
             reload(){
                this.loading = true;
                checkWork({copyrightRegisterAuthCertNo:this.certNo,copyrightRegisterHash:this.fileHash}).then(res=>{
                    if(res.code == 200){
                        router.push({
                            path:"/work/check/success",
                            query:{
                                certNo:this.certNo,
                                fileHash:this.fileHash
                            }
                        });
                    }
                    this.closeLoading();
                }).catch(e=>{
                    this.closeLoading();
                })
             },
             closeLoading(){
                setTimeout(()=>{
                    this.loading = false;
                },500)
                
             },
             backPage(){
                router.go(-1);
             }
        }
     }
</script>

<style lang="less" scoped>
.main-check-work{
    margin-top: 68px;
    text-align: left;
    .check-work{
        width: 1200px;
        margin: 0 auto;
        padding-top: 100px;
    }
}
    
</style>